import { useQuery } from "react-query";
import { toast } from "react-toastify";
import {   getPendingAbsences } from "api/Employee";

export const usePendingAbsenceRequests = () => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['pendingAbsences'],
        () => {
            return getPendingAbsences();
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
